
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "layout": "post",
  "title": "Queue for the iPhone 6",
  "date": "2014-09-19 17",
  "comments": "true",
  "categories": "[\"photo\", \"philadelphia\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "created": "2014-09-19",
  "tags": [
    "photo",
    "philadelphia"
  ],
  "draft": false
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":["The line outside the Apple Store in Philly for the iPhone 6 this morning was a sight to behold.\n",{"type":"img","props":{"src":"/static/images/posts/20140919-DSCF5742.jpg","alt":"Apple"}}]},"\n",{"type":"blockquote","props":{"class":"twitter-tweet","data-cards":"hidden","lang":"en"},"children":[{"type":"p","props":{},"children":["iPhone 6 line at the Apple Store in Philadelphia. Running down Walnut, around the corner, and up 17th to Sansom. ",{"type":"a","props":{"href":"http://t.co/QGm8cD5rr1"},"children":["pic.twitter.com/QGm8cD5rr1"]}]},"— Karl! (@_ksho) ",{"type":"a","props":{"href":"https://twitter.com/_ksho/status/512968599745880064"},"children":["September 19, 2014"]}]}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
